export default __webpack_public_path__ + "images/e58a27d21afddb9db0bb095181e4b91b-charlotte_mobile.webp";